import { createApp } from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import i18n, { setI18nLocale } from './api/i18n';
import apiClient from './api/index';
import mainPlugins from '@/plugins/mainPlugins.js';
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';
import { onHttpError } from '@/utils/http-error-events';
import { createHttpErrorHandler } from '@/utils/http-error-handler';
import { translateWithFallback } from '@/utils/i18n';
import { setLoading, setNavigationLoading } from '@/plugins/loading';
import 'sweetalert2/dist/sweetalert2.min.css';
const app = createApp(App);
const t = i18n.global.t;
const te = i18n.global.te;

const translate = (key, fallback, options) =>
    translateWithFallback(t, key, fallback, options, te);

const handleHttpError = createHttpErrorHandler({
    Swal,
    router,
    store,
    translate,
    setLoading,
    setNavigationLoading,
});

const loadInitialLanguage = async locale => {
    const response = await apiClient.get(
        `/languages/lang/${locale}?disable_cache=false`,
        { skipAuthorization: true }
    );
    i18n.global.setLocaleMessage(locale, response.data);
    i18n.global.locale.value = locale;
    setI18nLocale(locale, response.data);
    store.commit('i18n/setLocale', { locale, messages: response.data });
};

const initializeApp = async () => {
    const defaultLocale = localStorage.getItem('locale') || 'en';
    try {
        await loadInitialLanguage(defaultLocale);
    } catch (e) {
        console.error(
            'Failed to load initial language, proceeding with fallback.',
            e
        );
    }

    onHttpError(handleHttpError);

    app.use(mainPlugins);
    app.use(store);
    app.use(router);
    app.use(i18n);

    app.use(VueSweetalert2);

    app.mount('#app');
};

initializeApp();
